import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { sitesOptions } from "../queries/sitesQueries";
import { transformSiteInfoResponse } from "../sitesUtils";
import type { ISiteInfoConfig, ISiteLobInfoParams, ISiteLobInfoQueryOptions, SiteInfoResponse } from "../types";

export const useSiteLobInfo = (
    params: ISiteLobInfoParams,
    config?: ISiteInfoConfig,
    options?: ISiteLobInfoQueryOptions,
): UseQueryResult<SiteInfoResponse> => {
    return useQuery({
        ...sitesOptions.siteLobInfo(params, config, options),
        select: transformSiteInfoResponse,
    });
};
